
















































import { Component, Prop, Vue } from 'vue-property-decorator';
const DataSet = require('@antv/data-set');

const sourceData = [
  {item: '引用', a: 70, b: 30, c: 40},
  {item: '口碑', a: 60, b: 70, c: 40},
  {item: '产量', a: 50, b: 60, c: 40},
  {item: '贡献', a: 40, b: 50, c: 40},
  {item: '热度', a: 60, b: 70, c: 40},
  {item: '引用', a: 70, b: 50, c: 40},
];

const dv = new DataSet.View().source(sourceData);
dv.transform({
  type: 'fold',
  fields: ['a', 'b', 'c'],
  key: 'user',
  value: 'score',
});

const scale = [{
  dataKey: 'score',
  min: 0,
  max: 80,
}];

const data = dv.rows;

const axis1Opts = {
  dataKey: 'item',
  line: null,
  tickLine: null,
  grid: {
    lineStyle: {
      lineDash: null,
    },
    hideFirstLine: false,
  },
};

const axis2Opts = {
  dataKey: 'score',
  line: null,
  tickLine: null,
  grid: {
    type: 'polygon',
    lineStyle: {
      lineDash: null,
    },
  },
};

@Component({
  components: {
  },
})
export default class Radar extends Vue {

  private sourceData = sourceData;
  private data = data;
  private axis1Opts = axis1Opts;
  private axis2Opts = axis2Opts;
  private scale = scale;

}
